import { render, staticRenderFns } from "./relate.vue?vue&type=template&id=ca57cbfe&scoped=true"
import script from "./relate.vue?vue&type=script&lang=js"
export * from "./relate.vue?vue&type=script&lang=js"
import style0 from "./relate.vue?vue&type=style&index=0&id=ca57cbfe&prod&lang=css"
import style1 from "./relate.vue?vue&type=style&index=1&id=ca57cbfe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca57cbfe",
  null
  
)

export default component.exports